import { ReactElement } from 'react';
import { getMessagingDate, dateToAge } from '@utils/timeHelpers';
import { ItemFields, UserData } from './types';
import {useTranslation} from "react-i18next";

/**
* Build fields for User Information Page
* @param {UserData} userData - All data for user
* @param {ReactElement} statusSelect - Select for status
* @returns {Array<ItemFields>} - All fields for User Information Page
*/
export const userInformationFields = (
  userData: UserData,
  statusSelect: ReactElement,
  businessUnitsContent: ReactElement,
  phoneContent: ReactElement | null,
  nameContent: ReactElement | string,
): Array<ItemFields> => {
  const {t} = useTranslation()
  return [
    { id: 'userName', label: <span>{t('Informative.Labels.name' as any)}</span>, content: nameContent },
    { id: 'email', label: <span>{t('Informative.Labels.email' as any)}</span>, content: userData.email },
    ...(phoneContent ? [{
      id: 'phone',
      label: <span>{t('Authentication.MFA.phoneLabel')}</span>,
      content: phoneContent,
    }] : []),
    { id: 'businessUnits', label: <span>{t('Informative.Labels.businessUnits' as any)}</span>, content: businessUnitsContent },
    { id: 'status', label: <span>{t('Informative.Labels.status' as any)}</span>, content: statusSelect },
  ];
}
